import { Text } from "@clipboard-health/ui-components";
import { CollapsableAlert } from "@src/appV2/redesign/components/CollapsableAlert";

export function getTimesheetReviewAlertContent(params: {
  isShiftVerified: boolean;
  isInstantPay: boolean;
}): { title: string; description: string } {
  const { isShiftVerified, isInstantPay } = params;

  if (isShiftVerified) {
    return {
      title: "You are requesting a shift adjustment",
      description:
        "Your request may be reviewed first. You\u2019ll receive a response within 3 business days, and your additional shift pay immediately upon approval.",
    };
  }

  if (isInstantPay) {
    return {
      title: "Your adjusted time is pending workplace approval.",
      description:
        "Your request may be reviewed first, and you\u2019ll receive a response within 3 business days. Don\u2019t worry \u2013 you\u2019ll still receive shift pay based on your original clock in time.",
    };
  }

  return {
    title: "You are requesting a shift payment",
    description:
      "Your request may be reviewed first. You\u2019ll receive a response within 3 business days, and your shift pay immediately upon approval.",
  };
}

interface TimesheetReviewAlertProps {
  isShiftVerified: boolean;
  isInstantPay: boolean;
}

export function TimesheetReviewAlert(props: TimesheetReviewAlertProps) {
  const { isShiftVerified, isInstantPay } = props;
  const { title, description } = getTimesheetReviewAlertContent({ isShiftVerified, isInstantPay });

  return (
    <CollapsableAlert title={title}>
      <Text variant="caption">{description}</Text>
    </CollapsableAlert>
  );
}
